// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__xG9cB","slide-in-out":"List_slide-in-out__YPglZ","fade-in-out":"List_fade-in-out__7AG9k"};